export const regexRegistrationNumber = /[a-zA-Z]{3}\d{2}(d||[a-zA-Z]){1}/;
export const regexEmail = /\S+@\S+\.\S+/;
export const regexNumber = /\D/g;
